import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
export { default as img1 } from './images/1.webp';
export { default as img2 } from './images/2.webp';
export { default as img3 } from './images/3.webp';
export { default as img4 } from './images/4.webp';
export { default as img5 } from './images/5.webp';
export { default as img6 } from './images/6.webp';
export { default as img7 } from './images/7.webp';
export { default as img8 } from './images/8.webp';
export { default as img9 } from './images/9.webp';
export { default as img10 } from './images/10.webp';
export { default as img11 } from './images/11.webp';
export { default as img12 } from './images/12.webp';
export { default as img13 } from './images/13.webp';
export { default as img14 } from './images/14.webp';
export { default as img15 } from './images/15.webp';
export { default as img16 } from './images/16.webp';
export { default as img17 } from './images/17.webp';
export { default as img18 } from './images/18.webp';
export { default as img19 } from './images/19.webp';
export { default as img20 } from './images/20.webp';
export { default as img21 } from './images/21.webp';
export { default as img22 } from './images/22.webp';
export { default as img23 } from './images/23.webp';
export { default as img24 } from './images/24.webp';
export { default as img25 } from './images/25.webp';
export { default as img26 } from './images/26.webp';
export { default as img27 } from './images/27.webp';
export { default as img28 } from './images/28.webp';
export { default as img29 } from './images/29.webp';
export { default as img30 } from './images/30.webp';
export { default as img31 } from './images/31.webp';
export { default as img32 } from './images/32.webp';

export { default as logo } from './images/logo.png';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
